import {
  filterOpts,
  InventoryQueryParams,
} from '@services/queries/equipments/getEquipments/makeParamsObject';
import { Context } from '@store/machines/equipmentsPicker.schema';
import { EditModes } from '../components/OnBoardingModal/components/RightSide';
import { GROUP_EDIT_LIMIT } from '../Products';

export function getEditMode(
  context: Context,
  queryParams: Partial<InventoryQueryParams>,
): EditModes {
  const { lastAction, data: equipments } = context;
  if (equipments.size > GROUP_EDIT_LIMIT && lastAction === 'SELECT-ALL') {
    const hasFilter = Object.keys(queryParams).some(param =>
      filterOpts.includes(param),
    );
    if (hasFilter) return 'GROUP-LAMBDA-FILTER';
    return 'GROUP-LAMBDA-ALL';
  }
  if (equipments.size > GROUP_EDIT_LIMIT) return 'GROUP-OLD';
  return 'SINGLE';
}
